<template lang="pug">

    .ui.labels
        router-link.ui.label(:to='{ name: "addresses", query: allQuery }' exact)
            | Alle:
            .ui.detail {{ counts.all }}
        router-link.ui.label(:to='{ name: "addresses", query: shippingQuery }' exact)
            | Lieferadresse:
            .ui.detail {{ counts.shipping }}
        router-link.ui.label(:to='{ name: "addresses", query: correspondenceQuery }' exact)
            | Korrespondenzadresse:
            .ui.detail {{ counts.correspondence }} 
        router-link.ui.label(:to='{ name: "addresses", query: billingQuery }' exact)
            | Rechnungsadresse:
            .ui.detail {{ counts.billing }}

</template>

<script>
    import * as R from 'ramda'
    import toNumber from 'lodash/fp/toNumber'

    function apply_query(query, ctx) {
        if (R.is(Number, ctx.companyId)) {
            query.company = ctx.companyId
        }

        return query
    }

    // noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            allQuery() {
                return apply_query({}, this)
            },

            billingQuery() {
                return apply_query({ filter: 'BILLING' }, this)
            },

            correspondenceQuery() {
                return apply_query({ filter: 'CORRESPONDENCE'}, this)
            },

            companyId() {
                return R.compose(

                    R.when(R.equals(NaN), R.always(null)),

                    // Nach Nummer parsen
                    toNumber

                )(this.$route.query.company)
            },

            shippingQuery() {
                return apply_query({ filter: 'SHIPPING' }, this)
            },

        },

        props: {

            counts: {
                type: Object,
                required: true
            }

        }

    }

</script>
